import { map } from 'lodash'
import { UnitData } from '../apis/unit.api'

export default {
  selectOptions (units: UnitData[]) {
    return map(units, unit => {
      const { name, id } = unit
      return { name, value: String(id) }
    })
  },

  inputSelectOptions (units: string[]) {
    return map(units, unit => {
      return { name: unit, value: unit }
    })
  }
}
